import 'date-fns';
import koLocale from 'date-fns/locale/ko';
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {
    Button,
    Card,
    CardContent,
    Grid,
    FormControl,
} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

const useStyles = makeStyles((theme) => ({
    root: {},
    formControl: {
        marginRight: theme.spacing(1),
    },
    select: {},
    icon: {
        marginRight: '12px',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));



const Calendar = props => {
    const {className, start_date_option, comparison_date_option, onSubmit, ...rest} = props;
    const classes = useStyles(props);
    const MESSAGE = {
        ERROR_DATE: 'Select different reference date and comparison date',
    };

    const getDigit = num => num < 10 ? `0${num}` : num.toString();
    const getFullDate = (date, format = 'yyyy/MM/dd') => {
        const year = date.getFullYear();
        const month = getDigit(date.getMonth()+1);
        const dt = getDigit(date.getDate());

        return format === 'yyyy/MM/dd' ? `${year}-${month}-${dt}` : `${year}-${month}`;
    };

    // 기준 일 선택
    const [standardDate, setStandardDate] = React.useState(getFullDate(start_date_option.date, start_date_option.format));
    const handleStandardDateChange = date => {
        setStandardDate(getFullDate(date, start_date_option.format));
    };

    // 비교 일 선택
    const [comparisonDate, setComparisonDate] = React.useState(getFullDate(comparison_date_option.date, comparison_date_option.format));
    const handleComparisonDateChange = date => {
        setComparisonDate(getFullDate(date, comparison_date_option.format));
    };

    function enableMonday(date) {
        return date.getDay() === 0 || date.getDay() === 2 || date.getDay() === 3 || date.getDay() === 4 ||
            date.getDay() === 5 || date.getDay() === 6;
    }

    const submitHandler = (e) => {
        e.preventDefault();

        if (standardDate === comparisonDate) {
            alert(MESSAGE.ERROR_DATE);
            return;
        }

        onSubmit({
            targetDate: standardDate,
            compareDate: comparisonDate,
        });
    };

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardContent>
                <Grid
                    alignItems="flex-end"
                    container
                    spacing={2}
                >
                    <Grid
                        item
                        md={5}
                        sm={5}
                        xs={12}
                    >
                        <FormControl
                            className={classes.formControl}
                            fullWidth
                        >
                            <MuiPickersUtilsProvider
                                locale={koLocale}
                                utils={DateFnsUtils}
                            >
                                <KeyboardDatePicker
                                    autoOk
                                    disableFuture
                                    disableToolbar
                                    format={start_date_option.format}
                                    id="standard_date"
                                    label={start_date_option.label}
                                    maxDate={start_date_option.date}
                                    onChange={handleStandardDateChange}
                                    openTo={start_date_option.openTo}
                                    orientation="portrait"
                                    value={standardDate}
                                    variant="inline"
                                    views={start_date_option.views}
                                    shouldDisableDate={(start_date_option.enableMonday ? enableMonday : null)}
                                />
                            </MuiPickersUtilsProvider>
                        </FormControl>
                    </Grid>
                    <Grid
                        item
                        md={5}
                        sm={5}
                        xs={12}
                    >
                        <FormControl
                            className={classes.formControl}
                            fullWidth
                        >
                            <MuiPickersUtilsProvider
                                locale={koLocale}
                                utils={DateFnsUtils}
                            >
                                <KeyboardDatePicker
                                    autoOk
                                    disableFuture
                                    disableToolbar
                                    format={comparison_date_option.format}
                                    id="comparison_date"
                                    label={comparison_date_option.label}
                                    onChange={handleComparisonDateChange}
                                    openTo={comparison_date_option.openTo}
                                    orientation="portrait"
                                    maxDate={comparison_date_option.date}
                                    value={comparisonDate}
                                    variant="inline"
                                    views={comparison_date_option.views}
                                    shouldDisableDate={(comparison_date_option.enableMonday ? enableMonday : null)}
                                />
                            </MuiPickersUtilsProvider>
                        </FormControl>
                    </Grid>
                    <Grid
                        item
                        md={2}
                        sm={2}
                        xs={12}
                    >
                        <Button
                            color="primary"
                            fullWidth
                            onClick={submitHandler}
                            size="small"
                            variant="outlined"
                        >
                            Search
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

Calendar.propTypes = {
    className: PropTypes.string,
    comparison_date_option: PropTypes.object,
    start_date_option: PropTypes.object,
    onSubmit: PropTypes.func,
    report: PropTypes.string
};

export default Calendar;
